var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fc94101fa81017a30f1a523396145da503b53ca1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@plaxswap"]={id:"fc94101fa81017a30f1a523396145da503b53ca1"};
      